export const IsAlmacenBultosSkim = (formValues) => {
    if (!formValues) return false;
    if (!formValues.almacen) return false;

    return formValues.almacen && formValues.almacen.requiere_bultos_skim;
};